module.exports = __webpack_public_path__ + "img/left-arrow-back.6419aeec.svg";